/* Wild Islay Studio theme: sticker sheet calculator (product page block).
   Reads a typed request such as "3 inch hearts" or "60 x 30mm labels" and works out
   how many fit on the printable area of one A4 sheet. */
(function () {
  'use strict';

  if (window.wisStickerCalc) return;
  window.wisStickerCalc = true;

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var PAGE_W = 210;
  var PAGE_H = 297;
  var UNIT_MM = { mm: 1, cm: 10, 'in': 25.4 };

  /* Words customers use, the shape name shown, and how it is drawn. First match wins. */
  var SHAPES = [
    [/heart/, 'Heart', 'heart'],
    [/star/, 'Star', 'star'],
    [/hex/, 'Hexagon', 'hexagon'],
    [/triang/, 'Triangle', 'triangle'],
    [/diamond|rhomb/, 'Diamond', 'diamond'],
    [/scallop/, 'Scalloped circle', 'ellipse'],
    [/arch|rainbow/, 'Arch', 'arch'],
    [/tear|drop/, 'Teardrop', 'free'],
    [/cloud/, 'Cloud', 'free'],
    [/banner|ribbon/, 'Banner', 'rect'],
    [/\btags?\b/, 'Tag', 'rounded'],
    [/oval|ellip|egg/, 'Oval', 'ellipse'],
    [/round(ed)?[\s-]*(corner|edge)|rounded|radius/, 'Rounded rectangle', 'rounded'],
    [/circ|round|dot|disc/, 'Circle', 'ellipse'],
    [/square/, 'Square', 'rect'],
    [/rect|oblong|label|strip/, 'Rectangle', 'rect'],
    [/logo|custom|shape|die[\s-]*cut|kiss[\s-]*cut|contour|cut[\s-]*out|outline/, 'Custom shape', 'free']
  ];

  function positive(value, fallback) {
    var n = parseFloat(value);
    return isFinite(n) && n > 0 ? n : fallback;
  }

  function trim(text) {
    return String(text).replace(/^\s+|\s+$/g, '');
  }

  function tidy(n) {
    return String(Math.round(n * 10) / 10);
  }

  function sizeLabel(w, h) {
    return Math.abs(w - h) < 0.05 ? tidy(w) + 'mm' : tidy(w) + ' × ' + tidy(h) + 'mm';
  }

  function unitOf(word) {
    if (!word) return null;
    if (word.charAt(0) === 'c') return 'cm';
    if (word.charAt(0) === 'i') return 'in';
    return 'mm';
  }

  /* Turns what the customer typed into a shape, a width and a height in mm. */
  function readRequest(text) {
    var plain = String(text || '').toLowerCase();
    var out = { shape: 'Sticker', kind: 'rounded', w: null, h: null, quantity: null, guessedUnit: false };

    for (var s = 0; s < SHAPES.length; s++) {
      if (SHAPES[s][0].test(plain)) {
        out.shape = SHAPES[s][1];
        out.kind = SHAPES[s][2];
        break;
      }
    }

    var t = plain;
    t = t.replace(/[×✕✖*]/g, 'x');
    t = t.replace(/[″“”"]|''/g, ' in ');
    t = t.replace(/(\d),(\d{1,2})(?!\d)/g, '$1.$2');
    t = t.replace(/(\d+)\s+(\d+)\/(\d+)/g, function (m, a, b, c) { return String(+a + (+c ? +b / +c : 0)); });
    t = t.replace(/(\d+)\/(\d+)/g, function (m, a, b) { return +b ? String(+a / +b) : m; });
    t = t.replace(/\bby\b/g, ' x ');
    t = t.replace(/x(?=\s*\.?\d)/g, ' x ');

    var finder = /(\d+(?:\.\d+)?|\.\d+)\s*(millimet(?:re|er)s?|mm|centimet(?:re|er)s?|cm|inch(?:es)?|ins?)?(?![a-z])/g;
    var numbers = [];
    var match;
    while ((match = finder.exec(t)) !== null) {
      var before = match.index > 0 ? t.charAt(match.index - 1) : ' ';
      if (/[a-z]/.test(before)) continue;
      numbers.push({ value: parseFloat(match[1]), unit: unitOf(match[2]), start: match.index, end: match.index + match[0].length });
    }
    if (!numbers.length) return out;

    var first = null;
    var second = null;
    for (var i = 0; i < numbers.length - 1; i++) {
      if (/^\s*x\s*$/.test(t.slice(numbers[i].end, numbers[i + 1].start))) {
        first = numbers[i];
        second = numbers[i + 1];
        break;
      }
    }

    var spare = [];
    var k;
    if (first) {
      for (k = 0; k < numbers.length; k++) {
        if (numbers[k] !== first && numbers[k] !== second && !numbers[k].unit) spare.push(numbers[k]);
      }
    } else {
      var sized = [];
      for (k = 0; k < numbers.length; k++) {
        if (numbers[k].unit) sized.push(numbers[k]); else spare.push(numbers[k]);
      }
      if (sized.length >= 2) {
        first = sized[0];
        second = sized[1];
      } else if (sized.length === 1) {
        first = sized[0];
        second = sized[0];
      } else {
        first = numbers[0];
        second = numbers.length > 1 ? numbers[1] : numbers[0];
        spare = [];
      }
    }

    var unitA = first.unit || second.unit;
    var unitB = second.unit || first.unit;
    if (!unitA) {
      unitA = 'mm';
      unitB = 'mm';
      out.guessedUnit = true;
    }
    out.w = first.value * UNIT_MM[unitA];
    out.h = second.value * UNIT_MM[unitB];

    for (k = 0; k < spare.length; k++) {
      if (spare[k].value >= 1 && spare[k].value % 1 === 0) {
        out.quantity = spare[k].value;
        break;
      }
    }

    var same = Math.abs(out.w - out.h) < 0.05;
    if (out.shape === 'Circle' && !same) out.shape = 'Oval';
    if (out.shape === 'Square' && !same) out.shape = 'Rectangle';
    if (out.shape === 'Rectangle' && same) out.shape = 'Square';
    if (out.shape === 'Rounded rectangle' && same) out.shape = 'Rounded square';
    if (out.shape === 'Sticker' && !same) out.kind = 'rect';
    return out;
  }

  /* Reads the "Fixed answers" setting: shape, width in mm, height in mm, number per sheet. */
  function readFixed(text) {
    var list = [];
    var lines = String(text || '').split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var parts = lines[i].split(',');
      var w = parseFloat(parts[1]);
      var h = parseFloat(parts[2]);
      var count = parseInt(parts[3], 10);
      if (!trim(parts[0]) || !isFinite(w) || !isFinite(h) || !isFinite(count) || count < 1) continue;
      list.push({ shape: trim(parts[0]).toLowerCase(), w: w, h: h, count: count });
    }
    return list;
  }

  function fixedCount(list, shape, w, h) {
    var name = shape.toLowerCase();
    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      if (item.shape !== 'any' && item.shape !== name) continue;
      var upright = Math.abs(item.w - w) <= 0.5 && Math.abs(item.h - h) <= 0.5;
      var turned = Math.abs(item.w - h) <= 0.5 && Math.abs(item.h - w) <= 0.5;
      if (upright || turned) return item.count;
    }
    return null;
  }

  /* Rows and columns of one sticker size on the printable area, with a gap between stickers. */
  function grid(w, h, cfg) {
    var cols = Math.floor((cfg.width + cfg.gap) / (w + cfg.gap) + 1e-9);
    var rows = Math.floor((cfg.height + cfg.gap) / (h + cfg.gap) + 1e-9);
    if (cols < 0) cols = 0;
    if (rows < 0) rows = 0;
    return { cols: cols, rows: rows, count: cols * rows, w: w, h: h };
  }

  /* Tries the sticker both ways round and keeps whichever fits more. */
  function bestFit(w, h, cfg) {
    var upright = grid(w, h, cfg);
    var turned = grid(h, w, cfg);
    return turned.count > upright.count ? turned : upright;
  }

  /* A tidy arrangement for a set number per sheet (from the fixed answers list). */
  function layoutFor(count, w, h, cfg) {
    var options = [grid(w, h, cfg), grid(h, w, cfg)];
    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      for (var cols = option.cols; cols >= 1; cols--) {
        if (count % cols === 0 && count / cols <= option.rows) {
          return { cols: cols, rows: count / cols, count: count, w: option.w, h: option.h };
        }
      }
    }
    var fit = bestFit(w, h, cfg);
    var shown = Math.min(count, fit.count);
    var rows = fit.cols ? Math.ceil(shown / fit.cols) : 0;
    return { cols: fit.cols, rows: rows, count: shown, w: fit.w, h: fit.h };
  }

  /* Sheet packs: sizes and prices read from the product's options dropdown, when every option is a number of sheets. */
  function readPacks(form) {
    var select = form ? form.querySelector('[data-variant-select]') : null;
    var packs = [];
    if (!select) return packs;
    for (var i = 0; i < select.options.length; i++) {
      var option = select.options[i];
      var found = /^\s*(\d+)\s*(?:x\s*)?(?:a4\s*)?sheets?\b/i.exec(option.textContent);
      if (!found) return [];
      if (option.getAttribute('data-available') === 'false') continue;
      var priceText = String(option.getAttribute('data-price-html') || '').replace(/<[\s\S]*$/, '');
      var price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
      packs.push({
        id: option.value,
        size: parseInt(found[1], 10),
        price: isFinite(price) ? price : null,
        symbol: trim(priceText.replace(/[0-9.,\s]+$/, ''))
      });
    }
    return packs;
  }

  /* The cheapest single pack size (times a quantity) that covers the sheets needed. */
  function bestPack(packs, sheets) {
    var best = null;
    for (var i = 0; i < packs.length; i++) {
      var pack = packs[i];
      if (pack.size < 1) continue;
      var quantity = Math.ceil(sheets / pack.size);
      var option = { pack: pack, quantity: quantity, sheets: quantity * pack.size, cost: pack.price === null ? null : quantity * pack.price };
      if (!best) {
        best = option;
        continue;
      }
      var better;
      if (option.cost !== null && best.cost !== null) {
        if (Math.abs(option.cost - best.cost) > 0.004) better = option.cost < best.cost;
        else better = option.sheets > best.sheets;
      } else {
        better = option.sheets < best.sheets || (option.sheets === best.sheets && option.quantity < best.quantity);
      }
      if (better) best = option;
    }
    return best;
  }

  /* The cheapest mix of two pack sizes that covers the sheets needed (the customer adds each to the basket). */
  function cheapestMix(packs, sheets) {
    var best = null;
    if (sheets > 2000) return null;
    for (var i = 0; i < packs.length; i++) {
      for (var j = 0; j < packs.length; j++) {
        var big = packs[i];
        var small = packs[j];
        if (big.price === null || small.price === null || big.size <= small.size || small.size < 1) continue;
        for (var bigQty = 1; bigQty * big.size < sheets; bigQty++) {
          var smallQty = Math.ceil((sheets - bigQty * big.size) / small.size);
          var cost = bigQty * big.price + smallQty * small.price;
          if (!best || cost < best.cost - 0.004) {
            best = {
              cost: cost,
              text: bigQty + ' x ' + big.size + ' sheets + ' + smallQty + ' x ' + small.size + (small.size === 1 ? ' sheet' : ' sheets')
            };
          }
        }
      }
    }
    return best;
  }

  /* Packs sold as a number of labels or stickers, such as "100 labels": the number and the word, read from the chosen option. */
  function readPackCount(form) {
    var select = form ? form.querySelector('[data-variant-select]') : null;
    if (!select || select.selectedIndex < 0) return null;
    var found = /(\d+)\s*(label|sticker)s?\b/i.exec(select.options[select.selectedIndex].textContent);
    return found ? { size: parseInt(found[1], 10), word: found[2].toLowerCase() } : null;
  }

  function packName(choice) {
    var size = choice.pack.size;
    if (choice.quantity === 1) return size === 1 ? '1 sheet' : 'the ' + size + ' sheet pack';
    return choice.quantity + ' x ' + (size === 1 ? '1 sheet' : size + ' sheet pack');
  }

  function svgEl(name, attrs) {
    var node = document.createElementNS(SVG_NS, name);
    for (var key in attrs) {
      if (Object.prototype.hasOwnProperty.call(attrs, key)) node.setAttribute(key, attrs[key]);
    }
    return node;
  }

  function polygon(x, y, w, h, points) {
    var list = [];
    for (var i = 0; i < points.length; i += 2) {
      list.push(tidy(x + points[i] * w) + ',' + tidy(y + points[i + 1] * h));
    }
    return svgEl('polygon', { points: list.join(' ') });
  }

  function shapeNode(kind, x, y, w, h) {
    function px(n) { return tidy(x + n * w); }
    function py(n) { return tidy(y + n * h); }
    if (kind === 'ellipse') {
      return svgEl('ellipse', { cx: x + w / 2, cy: y + h / 2, rx: w / 2, ry: h / 2 });
    }
    if (kind === 'heart') {
      return svgEl('path', { d: 'M' + px(0.5) + ' ' + py(0.28) +
        ' C' + px(0.5) + ' ' + py(0.1) + ' ' + px(0.36) + ' ' + py(0) + ' ' + px(0.25) + ' ' + py(0) +
        ' C' + px(0.1) + ' ' + py(0) + ' ' + px(0) + ' ' + py(0.12) + ' ' + px(0) + ' ' + py(0.3) +
        ' C' + px(0) + ' ' + py(0.58) + ' ' + px(0.3) + ' ' + py(0.78) + ' ' + px(0.5) + ' ' + py(1) +
        ' C' + px(0.7) + ' ' + py(0.78) + ' ' + px(1) + ' ' + py(0.58) + ' ' + px(1) + ' ' + py(0.3) +
        ' C' + px(1) + ' ' + py(0.12) + ' ' + px(0.9) + ' ' + py(0) + ' ' + px(0.75) + ' ' + py(0) +
        ' C' + px(0.64) + ' ' + py(0) + ' ' + px(0.5) + ' ' + py(0.1) + ' ' + px(0.5) + ' ' + py(0.28) + ' Z' });
    }
    if (kind === 'arch') {
      return svgEl('path', { d: 'M' + px(0) + ' ' + py(1) + ' L' + px(0) + ' ' + py(0.5) +
        ' A' + tidy(w / 2) + ' ' + tidy(h / 2) + ' 0 0 1 ' + px(1) + ' ' + py(0.5) +
        ' L' + px(1) + ' ' + py(1) + ' Z' });
    }
    if (kind === 'star') {
      return polygon(x, y, w, h, [0.5, 0, 0.62, 0.36, 1, 0.38, 0.7, 0.61, 0.81, 0.98, 0.5, 0.76, 0.19, 0.98, 0.3, 0.61, 0, 0.38, 0.38, 0.36]);
    }
    if (kind === 'hexagon') return polygon(x, y, w, h, [0.25, 0, 0.75, 0, 1, 0.5, 0.75, 1, 0.25, 1, 0, 0.5]);
    if (kind === 'triangle') return polygon(x, y, w, h, [0.5, 0, 1, 1, 0, 1]);
    if (kind === 'diamond') return polygon(x, y, w, h, [0.5, 0, 1, 0.5, 0.5, 1, 0, 0.5]);
    var radius = 0;
    if (kind === 'rounded') radius = Math.min(w, h) * 0.16;
    if (kind === 'free') radius = Math.min(w, h) * 0.32;
    return svgEl('rect', { x: x, y: y, width: w, height: h, rx: radius, ry: radius });
  }

  /* Small picture of the A4 sheet with the stickers laid out on it. */
  function draw(target, layout, kind, cfg) {
    while (target.firstChild) target.removeChild(target.firstChild);
    var svg = svgEl('svg', { viewBox: '0 0 ' + PAGE_W + ' ' + PAGE_H, 'aria-hidden': 'true', focusable: 'false' });
    svg.appendChild(svgEl('rect', { x: 1, y: 1, width: PAGE_W - 2, height: PAGE_H - 2, 'class': 'sticker-calc__page' }));
    var totalW = layout.cols * layout.w + (layout.cols - 1) * cfg.gap;
    var totalH = layout.rows * layout.h + (layout.rows - 1) * cfg.gap;
    var x0 = (PAGE_W - totalW) / 2;
    var y0 = (PAGE_H - totalH) / 2;
    var drawn = 0;
    for (var r = 0; r < layout.rows; r++) {
      for (var c = 0; c < layout.cols; c++) {
        if (drawn >= layout.count) break;
        var shape = shapeNode(kind, x0 + c * (layout.w + cfg.gap), y0 + r * (layout.h + cfg.gap), layout.w, layout.h);
        shape.setAttribute('class', 'sticker-calc__shape');
        svg.appendChild(shape);
        drawn++;
      }
    }
    target.appendChild(svg);
  }

  function init(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', 'true');

    var gap = parseFloat(root.getAttribute('data-gap'));
    var cfg = {
      width: positive(root.getAttribute('data-width'), 172),
      height: positive(root.getAttribute('data-height'), 249),
      gap: isFinite(gap) && gap >= 0 ? gap : 3,
      min: positive(root.getAttribute('data-min'), 10)
    };

    var fixed = [];
    try {
      fixed = readFixed(JSON.parse(root.querySelector('[data-calc-fixed]').textContent));
    } catch (error) {
      fixed = [];
    }

    var askIn = root.querySelector('[data-calc-ask]');
    var messageEl = root.querySelector('[data-calc-message]');
    var resultEl = root.querySelector('[data-calc-result]');
    var previewEl = root.querySelector('[data-calc-preview]');
    var countEl = root.querySelector('[data-calc-count]');
    var unitEl = root.querySelector('[data-calc-unit]');
    var detailEl = root.querySelector('[data-calc-detail]');
    var needIn = root.querySelector('[data-calc-need]');
    var sheetsEl = root.querySelector('[data-calc-sheets]');
    var setBtn = root.querySelector('[data-calc-set]');
    var packRow = root.querySelector('[data-calc-pack-row]');
    var packEl = root.querySelector('[data-calc-pack]');
    var current = null;
    if (!askIn) return;

    /* "label" on products sold as a number of labels, otherwise "sticker". */
    function itemWord() {
      var pack = readPackCount(root.closest('form'));
      return pack ? pack.word : 'sticker';
    }

    function prop(name, value) {
      var input = root.querySelector('[data-calc-prop="' + name + '"]');
      if (!input) return;
      input.disabled = value === null;
      input.value = value === null ? '' : value;
    }

    function updateNeed() {
      if (!needIn) return;
      var want = parseInt(needIn.value, 10);
      if (!current || !isFinite(want) || want < 1) {
        sheetsEl.hidden = true;
        setBtn.hidden = true;
        prop('need', null);
        return;
      }
      var sheets = Math.ceil(want / current.count);
      var choice = bestPack(readPacks(root.closest('form')), sheets);
      if (choice) {
        var mix = cheapestMix(readPacks(root.closest('form')), sheets);
        var saving = mix && choice.cost !== null && mix.cost <= choice.cost * 0.95;
        sheetsEl.textContent = 'You need ' + sheets + (sheets === 1 ? ' sheet. ' : ' sheets. ') +
          (saving ? 'In one pack size: ' : 'Best value: ') + packName(choice) +
          (choice.cost === null ? '' : ' for ' + choice.pack.symbol + choice.cost.toFixed(2)) +
          ', about ' + choice.sheets * current.count + ' stickers.' +
          (saving ? ' Or pay less by adding a mix of packs to your basket: ' + mix.text + ', ' + choice.pack.symbol + mix.cost.toFixed(2) + '.' : '');
        setBtn.textContent = 'Choose ' + packName(choice);
        setBtn.setAttribute('data-variant', choice.pack.id);
        setBtn.setAttribute('data-sheets', String(choice.quantity));
      } else {
        sheetsEl.textContent = sheets + (sheets === 1 ? ' sheet gives you ' : ' sheets give you ') + sheets * current.count + ' stickers.';
        setBtn.textContent = 'Set quantity to ' + sheets;
        setBtn.removeAttribute('data-variant');
        setBtn.setAttribute('data-sheets', String(sheets));
      }
      sheetsEl.hidden = false;
      setBtn.hidden = false;
      prop('need', String(want));
    }

    /* For packs sold by number: the full sheets printed and how many the customer gets. */
    function updatePack() {
      if (!packRow || !packEl) return;
      var pack = current ? readPackCount(root.closest('form')) : null;
      if (!pack || pack.size < 1) {
        packRow.hidden = true;
        prop('pack', null);
        return;
      }
      var sheets = Math.ceil(pack.size / current.count);
      var total = sheets * current.count;
      var extra = total > pack.size;
      packEl.textContent = 'Your pack of ' + pack.size + ' is printed as ' + sheets + (sheets === 1 ? ' full A4 sheet' : ' full A4 sheets') +
        ', so you get ' + (extra ? 'about ' : '') + total + ' ' + pack.word + 's' +
        (extra ? ', and never fewer than ' + pack.size + '.' : '.');
      packRow.hidden = false;
      prop('pack', (extra ? 'About ' : '') + sheets + (sheets === 1 ? ' sheet, ' : ' sheets, ') + total + ' ' + pack.word + 's');
    }

    function clear(message) {
      current = null;
      messageEl.textContent = message;
      messageEl.hidden = !message;
      resultEl.hidden = true;
      prop('request', null);
      prop('shape', null);
      prop('size', null);
      prop('count', null);
      updateNeed();
      updatePack();
    }

    function update() {
      var typed = trim(askIn.value);
      if (!typed) {
        clear('');
        return;
      }
      var ask = readRequest(typed);
      if (ask.w === null) {
        clear('Add a size, for example 50mm, 5cm or 2 inches.');
        return;
      }
      if (ask.w < cfg.min || ask.h < cfg.min) {
        clear(ask.guessedUnit
          ? sizeLabel(ask.w, ask.h) + ' is too small to cut. If you meant cm or inches, add it after the number, for example ' + tidy(ask.w) + 'cm.'
          : 'That is too small to cut. The smallest ' + itemWord() + ' is ' + tidy(cfg.min) + 'mm.');
        return;
      }

      var count = fixedCount(fixed, ask.shape, ask.w, ask.h);
      var layout = count ? layoutFor(count, ask.w, ask.h, cfg) : bestFit(ask.w, ask.h, cfg);
      if (!count) count = layout.count;
      if (count < 1) {
        clear('That is bigger than one A4 sheet can take. The largest ' + itemWord() + ' is ' + tidy(cfg.width) + ' × ' + tidy(cfg.height) + 'mm.');
        return;
      }

      current = { count: count };
      messageEl.hidden = true;
      resultEl.hidden = false;
      countEl.textContent = String(count);
      unitEl.textContent = itemWord() + (count === 1 ? '' : 's') + ' per A4 sheet';
      detailEl.textContent = ask.shape + ', ' + sizeLabel(ask.w, ask.h) + '.';
      draw(previewEl, layout, ask.kind, cfg);
      prop('request', typed);
      prop('shape', ask.shape);
      prop('size', sizeLabel(ask.w, ask.h));
      prop('count', 'About ' + count);
      if (needIn && ask.quantity && (needIn.value === '' || needIn.getAttribute('data-auto') === 'true')) {
        needIn.value = String(ask.quantity);
        needIn.setAttribute('data-auto', 'true');
      }
      updateNeed();
      updatePack();
    }

    askIn.addEventListener('input', update);
    askIn.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') event.preventDefault();
    });

    var examples = root.querySelectorAll('[data-calc-example]');
    for (var e = 0; e < examples.length; e++) {
      examples[e].addEventListener('click', function () {
        askIn.value = trim(this.textContent);
        update();
      });
    }

    if (needIn) {
      needIn.addEventListener('input', function () {
        needIn.removeAttribute('data-auto');
        updateNeed();
      });
      setBtn.addEventListener('click', function () {
        var sheets = setBtn.getAttribute('data-sheets');
        var form = root.closest('form');
        if (!form || !sheets) return;
        var variantId = setBtn.getAttribute('data-variant');
        var picker = form.querySelector('[data-variant-select]');
        if (variantId && picker) {
          picker.value = variantId;
          picker.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var quantity = form.querySelector('[name="quantity"]');
        if (!quantity) {
          quantity = document.createElement('input');
          quantity.type = 'hidden';
          quantity.name = 'quantity';
          form.appendChild(quantity);
        }
        quantity.value = sheets;
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
        setBtn.textContent = variantId ? setBtn.textContent.replace(/^Choose/, 'Selected') : 'Quantity set to ' + sheets;
      });
    }

    /* A different pack size changes the total. Runs after the theme has shown or hidden the block for that option. */
    var packForm = root.closest('form');
    if (packRow && packForm) {
      packForm.addEventListener('change', function (event) {
        if (!event.target || !event.target.matches || !event.target.matches('[data-variant-select]')) return;
        window.setTimeout(function () {
          if (!root.closest('[hidden]')) updatePack();
        }, 0);
      });
    }

    root.hidden = false;
    update();
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll('[data-sticker-calc]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
